import MeliaWidget from './MeliaWidget';
import MeliaMainMenu from '../components/meliaMainMenu/MeliaMainMenu';
import Autocomplete from '../components/autocomplete/Autocomplete';
import GooglePlacesAutocomplete from 'components/autocomplete/providers/GoogleAutocomplete';
import DestinationsTreeProvider from '../layers/providers/DestinationsTreeProvider';
import destinationTreeLayer from '../layers/DestinationsTreeLayer';
import ListHotelsProvider from '../components/autocomplete/providers/ListHotelsProvider';
import hotelSummaryMobilePanel from '../components/hotelSummaryMobilePanel/hotelSummaryMobilePanel';
import HotelLocation from '../components/hotelLocation/HotelLocation';
import MessageControl from 'components/messageControl/MessageControl';

export default MeliaWidget.extend({
	constructor(containerId, config, api) {
		MeliaWidget.prototype.constructor.call(this, containerId, config, api);
	},

	initialize() {
		MeliaWidget.prototype.initialize.call(this);
	},

	onInitialized() {
		MeliaWidget.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(
			new MeliaMainMenu({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'TOP_LEFT',
				visible: true,
				properties: {
					components: {
						BlockAutocomplete: {
							position: 'main-box-container',
							componentConstructorClass: 'BlockAutocomplete',
							properties: {}
						}
					}
				}
			})
		);

		this.addComponent(
			new HotelLocation({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'RIGHT_BOTTOM',
				visible: true,
				properties: {}
			})
		);

		this.addComponent(
			new MessageControl({
				identifier: `message-control${
					this.isMobileVersion ? '-mobile' : ''
				}`,
				position: 'TOP_RIGHT',
				widget: this
			})
		);

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}
	},

	addMobileComponents() {},

	registerConfigClasses(
		registerComponent,
		registerLayer,
		registerLayerProvider
	) {
		registerLayer('destinationTreeLayer', destinationTreeLayer);
		registerLayerProvider(
			'DestinationsTreeProvider',
			DestinationsTreeProvider
		);
		Autocomplete.registerProviderClass(
			'GPlacesAutocomplete',
			GooglePlacesAutocomplete
		);
		Autocomplete.registerProviderClass(
			'ListHotelsProvider',
			ListHotelsProvider
		);

		registerComponent('MeliaMainMenu', MeliaMainMenu);
		registerComponent('hotelSummaryMobilePanel', hotelSummaryMobilePanel);
		registerComponent('HotelLocation', HotelLocation);
		registerComponent('MessageControl', MessageControl);
	},

	initializeBaseLayer() {
		this.initBaseMapLayer();
		this.addLayer(
			new destinationTreeLayer({
				widget: this,
				provider: DestinationsTreeProvider,
				id: 'destinationTreeLayer',
				iconMarker: {
					default: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					hover: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					selected: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					}
				},
				featureId: 'id',
				minZoom: false,
				cluster: {
					options: {
						radius: 150,
						maxZoom: 13,
						minZoom: 0,
						extend: 512,
						nodeSize: 64,
						log: false
					},
					iconStyles: {
						url:
							this.config.clusterHotelsIcon ||
							'secondary-hotel-marker.svg'
					}
				}
			})
		);

		this.listenTo(this.bus, 'CLICK_ON_MARKER', marker => {
			if (marker.id && marker.layerId === 'destinationTreeLayer') {
				this.getMainHotelData(marker.id).then(hotelData => {
					const hotelMobileSummaryPanel = this.customComponents[
						'hotel-summary-panel'
					];
					if (this.isMobileVersion) {
						if (hotelMobileSummaryPanel) {
							hotelMobileSummaryPanel.$el.remove();
							hotelMobileSummaryPanel.remove();
						}
						this.addComponent(
							new hotelSummaryMobilePanel({
								identifier: 'hotel-summary-panel',
								widget: this,
								componentClass: 'hotel-summary-panel',
								classPrefix: 'hotel-summary-panel',
								position: 'BOTTOM_CENTER',
								visible: true,
								properties: {
									hotelData
								}
							})
						);
					} else {
						this.bus.trigger(
							'UPDATED_HOTEL_SELECTED_DATA',
							hotelData
						);
					}
				});
			}
		});
	},

	getDestinationsTreeData() {}
});



// WEBPACK FOOTER //
// ./src/widget/DestinationsTreeWidget.js